import type { IOidcSettings } from '../../types';

const getAuthSettings = async (): Promise<IOidcSettings> => {
  return fetch('../../public/oidc.config.json').then((response) => response.json());
};

export const authSettings = await getAuthSettings();
